import type { UmbracoFormField } from 'types/blocks';
import { useI18n } from 'vue-i18n';

export default function useForm() {
  const { t } = useI18n();

  function showLabel(field: UmbracoFormField): boolean {
    return field.settings.showLabel && !!field.caption;
  }

  function getLabel(field: UmbracoFormField): string {
    return field.required ? field.caption : `${field.caption} ${t('Forms.Labels.Optional')}`;
  }

  return { getLabel, showLabel };
}
